import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 97526C1D-E3B9-4900-8C13-3969E80949B3
 * name playlist-music-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/playlist-music-outline.svg
 * tags
 * - Music 
 */
export const PlaylistMusicOutlineIcon = createSvgIcon(<><path d="M15,6V8H3V6H15M15,10V12H3V10H15M3,16V14H11V16H3M17,6H22V8H19V17A3,3 0 0,1 16,20A3,3 0 0,1 13,17A3,3 0 0,1 16,14C16.35,14 16.69,14.07 17,14.18V6M16,16A1,1 0 0,0 15,17A1,1 0 0,0 16,18A1,1 0 0,0 17,17A1,1 0 0,0 16,16Z" /></>, 'PlaylistMusicOutlineIcon');
export default PlaylistMusicOutlineIcon